import React from 'react'
import { Breadcrumb, Container } from 'react-bootstrap'
import { Link, RouteComponentProps } from 'react-router-dom'

export const CKey = (props: RouteComponentProps<{ ckeyText: string }>) => {
  const ckeyRaw = props.match.params.ckeyText

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Gateway</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{ckeyRaw}</Breadcrumb.Item>
      </Breadcrumb>
      <h1 className="text-center">{ckeyRaw}</h1>
    </Container>
  )
}
